import React from "react";
import { connect } from 'react-redux';
import TemplateLabel from "./TemplateLabel";
import TemplateHint from "./TemplateHint";

const NoteTemplate = (props) => {
    return (
        <>
            {
                props.appearance.indexOf("text-nolabel") === -1 &&
                <TemplateLabel label={props["label::"+props.language]}  required={props.required}/>
            }
            <TemplateHint hint={props["hint::"+props.language]}/>
        </>
    );
};

const mapStateToProps = (state, props) => {
    return {
        ...props,
        ...state['questionsList'][props.questionId]
    };
}

export default connect(mapStateToProps)(NoteTemplate);